import { render } from "./VotesTableCategory.vue?vue&type=template&id=2fa9fc12"
import script from "./VotesTableCategory.vue?vue&type=script&lang=js"
export * from "./VotesTableCategory.vue?vue&type=script&lang=js"

import "./VotesTableCategory.vue?vue&type=style&index=0&id=2fa9fc12&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__